// extracted by mini-css-extract-plugin
module.exports = {"purchase":"purchase--guc1I","title":"title--2ObaK","content":"content--29GZ2","more":"more--2TvSn"};